import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ef19998"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-content" }
const _hoisted_2 = { class: "footer-wrap van-hairline--top" }

import { Overlay, Field } from 'vant'
import { withDefaults, computed } from 'vue'
import { useOverlayCommonInfo } from '@/compositions/common'


export default /*#__PURE__*/_defineComponent({
  __name: 'activity-dialog',
  props: {
    type: { default: 1 },
    show: { type: Boolean },
    needConfirm: { type: Boolean },
    notedText: { default: '我知道了' }
  },
  emits: ['update:show', 'cancel', 'confirm', 'notedTextClick'],
  setup(__props: any, { emit: emits }) {

const props = __props as { type: number, show: boolean, needConfirm?: boolean, notedText: string };


const { overlayHeightValue } = useOverlayCommonInfo()



const bgClass = computed(() => {
  return props.type === 1 ? 'activity-dialog-bg1' : 'activity-dialog-bg2'
})
function overlayClick() {}

function hideDialogHandle() {
  emits('update:show', false)
  emits('notedTextClick')
}

function cancelHandle() {
  emits('update:show', false)
  emits('cancel')
}

function confirmHandle() {
  // emits('update:show', false)
  emits('confirm')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Overlay), {
    show: __props.show,
    onClick: overlayClick,
    class: "overlay-wrap",
    style: _normalizeStyle({ height: _unref(overlayHeightValue) })
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["em-container content-wrap", _unref(bgClass)])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _createElementVNode("div", _hoisted_2, [
          (props.needConfirm)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", { onClick: cancelHandle }, "返回"),
                _createElementVNode("div", {
                  class: "van-hairline--left",
                  onClick: confirmHandle
                }, "确认")
              ], 64))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                onClick: hideDialogHandle
              }, _toDisplayString(props.notedText), 1))
        ])
      ], 2)
    ]),
    _: 3
  }, 8, ["show", "style"]))
}
}

})